// AppointmentForm.jsx
import React, { useState } from 'react';

const AppointmentForm = (props) => {
    const { formTitle, formSubTitle, formBtn, formBtnClass } = props;

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phoneNumber: '',
        yourWebsite: '',
        yourMessage: ''
    });

    const [statusMessage, setStatusMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setStatusMessage('');

        try {
            const response = await fetch('https://yautiktechnology.com/api/contactform', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            const contentType = response.headers.get('content-type');
            let result;

            if (!response.ok) {
                if (contentType && contentType.includes('application/json')) {
                    const errorData = await response.json();
                    setStatusMessage(errorData.message || 'Failed to submit the form.');
                } else {
                    const errorText = await response.text();
                    setStatusMessage(errorText || 'Failed to submit the form.');
                }
                return;
            }

            if (contentType && contentType.includes('application/json')) {
                result = await response.json();
                setStatusMessage(result.message || 'Form submitted successfully!');
            } else {
                const text = await response.text();
                setStatusMessage(text || 'Form submitted successfully!');
            }

            // Reset form after success
            setFormData({
                name: '',
                email: '',
                phoneNumber: '',
                yourWebsite: '',
                yourMessage: ''
            });

        } catch (error) {
            console.error('Error occurred:', error);
            setStatusMessage('A network error occurred. Please check your connection and try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <main>
            <div className="appointment-style white-bg">
                <div className="form-title">
                    <h3 className="title">{formTitle || 'Schedule Your Appointment'}</h3>
                    <p className="desc">{formSubTitle || 'We are here to help you 24/7 with experts'}</p>
                </div>
                <form className="appointment-form" onSubmit={handleSubmit}>
                    <input
                        type="text"
                        name="name"
                        placeholder="Name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                    <input
                        type="email"
                        name="email"
                        placeholder="E-Mail"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                    <input
                        type="text"
                        name="phoneNumber"
                        placeholder="Phone Number"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        required
                    />
                    <input
                        type="text"
                        name="yourWebsite"
                        placeholder="Your Website"
                        value={formData.yourWebsite}
                        onChange={handleChange}
                    />
                    <textarea
                        name="yourMessage"
                        placeholder="Type Your Message"
                        value={formData.yourMessage}
                        onChange={handleChange}
                        required
                    />
                    <button type="submit" className={formBtnClass || 'submit'} disabled={isSubmitting}>
                        {isSubmitting ? 'Submitting...' : formBtn || 'Submit Now'}
                    </button>
                </form>
                {statusMessage && <p className="status-message">{statusMessage}</p>}
            </div>
        </main>
    );
};

export default AppointmentForm;
